import { _converse, api } from '@converse/headless';
import { ObservableElement } from 'shared/components/observable.js';
import tplRequestingContact from './templates/requesting_contact.js';
import tplRosterItem from './templates/roster_item.js';
import tplUnsavedContact from './templates/unsaved_contact.js';
import { __ } from 'i18n';
import { blockContact, declineContactRequest, removeContact } from './utils.js';

export default class RosterContactView extends ObservableElement {
    /**
     * @typedef {import('shared/components/types').ObservableProperty} ObservableProperty
     */

    constructor() {
        super();
        this.model = null;
        this.observable = /** @type {ObservableProperty} */ ('once');
    }

    static get properties() {
        return {
            ...super.properties,
            model: { type: Object },
        };
    }

    initialize() {
        this.listenTo(this.model, 'change', () => this.requestUpdate());
        this.listenTo(this.model, 'highlight', () => this.requestUpdate());
        this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
        this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
        this.listenTo(this.model, 'presence:change', () => this.requestUpdate());
    }

    render() {
        if (this.model instanceof _converse.exports.RosterContact) {
            if (this.model.get('requesting') === true) {
                return tplRequestingContact(this);
            } else if (!this.model.get('subscription')) {
                return tplUnsavedContact(this);
            }
        }
        return tplRosterItem(this);
    }

    /**
     * @param {MouseEvent} ev
     */
    /**
     * @param {MouseEvent} ev
     */
    async openChat(ev) {
        ev?.preventDefault?.();
        const jid = this.model.get('jid');

        // Импортируем необходимые утилиты из окружения Converse
        const { $msg, u } = _converse.env;

        // 1. Открываем чат
        await api.chats.open(jid, {}, true);

        const cb = _converse.chatboxes.get(jid);
        if (cb) {
            // --- БЛОК АВТОМАТИЧЕСКОЙ ОТПРАВКИ MARKER ---
            setTimeout(() => {
                const messages = cb.messages.models;
                const unread = messages.filter(
                    (m) => m.get('sender') === 'them' && !m.get('displayed') && (m.get('body') || m.get('is_markable')),
                );

                const connection = _converse.connection || api.connection.get();

                if (connection && connection.connected) {
                    unread.forEach((msg) => {
                        const msg_id = msg.get('id');
                        console.log(`[Sonata] Auto-sending 'displayed' from Roster click: ${msg_id}`);

                        // Используем $msg (с долларом!) для генерации XML
                        const stanza = $msg({
                            'from': _converse.bare_jid,
                            'to': jid,
                            'id': connection.getUniqueId ? connection.getUniqueId() : u.getUniqueId(),
                            'type': 'chat',
                        }).c('displayed', {
                            'xmlns': 'urn:xmpp:chat-markers:0',
                            'id': msg_id,
                        });

                        connection.send(stanza.tree());

                        // Обновляем модель локально для отображения в UI
                        msg.save({
                            'displayed': new Date().toISOString(),
                            'chat_marker_state': 'displayed',
                        });
                    });
                } else {
                    console.warn('[Sonata] Cannot send marker: Connection is not ready.');
                }
            }, 600);
            // --------------------------------------------

            const updateData = {
                'num_unread': 0,
                'num_unread_general': 0,
                'last_read': new Date().toISOString(),
            };

            if (!cb.get('fullname') || !cb.get('nickname')) {
                updateData.fullname = this.model.get('fullname') || jid;
                updateData.nickname = this.model.get('fullname') || jid;
            }

            cb.save(updateData);
        }

        if (this.model && this.model.get('num_unread') !== 0) {
            this.model.save({ 'num_unread': 0 });
        }

        this.requestUpdate();
    }
    // async openChat(ev) {
    //     ev?.preventDefault?.();
    //     const jid = this.model.get('jid');

    //     console.group(
    //         `%c[ROSTER OPEN CHAT]: ${jid}`,
    //         'background: #222; color: #3498db; padding: 2px 5px; border-radius: 3px;',
    //     );

    //     // --- ЛОГИРОВАНИЕ СОСТОЯНИЯ РОСТЕРА ---
    //     const rosterContact = this.model;
    //     console.log('Roster Contact Model:', {
    //         jid: rosterContact.get('jid'),
    //         fullname: rosterContact.get('fullname'),
    //         nickname: rosterContact.get('nickname'),
    //         num_unread: rosterContact.get('num_unread'),
    //         subscription: rosterContact.get('subscription'),
    //     });

    //     // 1. Открываем чат
    //     await api.chats.open(jid, {}, true);

    //     // 2. Обнуляем в Chatbox
    //     const cb = _converse.chatboxes.get(jid);
    //     if (cb) {
    //         // --- ЛОГИРОВАНИЕ СОСТОЯНИЯ ЧАТБОКСА ---
    //         console.log('Chatbox Model (Before Fix):', {
    //             jid: cb.get('jid'),
    //             fullname: cb.get('fullname'),
    //             nickname: cb.get('nickname'),
    //             num_unread: cb.get('num_unread'),
    //             omemo_active: cb.get('omemo_active'),
    //         });

    //         // ПРОВЕРКА НА NULL NICKNAME
    //         if (cb.get('nickname') === null || cb.get('nickname') === undefined) {
    //             console.warn(
    //                 `%c[ALERT]: Nickname in Chatbox is ${cb.get('nickname')}! Fixing...`,
    //                 'color: orange; font-weight: bold;',
    //             );
    //         }

    //         const updateData = {
    //             'num_unread': 0,
    //             'num_unread_general': 0,
    //             'last_read': new Date().toISOString(),
    //         };

    //         // Если в чатбоксе имя пустое или null, подтягиваем из ростера
    //         if (!cb.get('fullname') || !cb.get('nickname')) {
    //             updateData.fullname = rosterContact.get('fullname') || jid;
    //             updateData.nickname = rosterContact.get('fullname') || jid;
    //         }

    //         cb.save(updateData);
    //     } else {
    //         console.error('Chatbox not found after api.chats.open!');
    //     }

    //     // 3. Обнуляем в самой модели контакта (this.model)
    //     if (this.model && this.model.get('num_unread') !== 0) {
    //         console.log('%c[FIX]: Clearing unread count on RosterContact', 'color: #2ecc71');
    //         this.model.save({
    //             'num_unread': 0,
    //         });
    //     }

    //     // 4. Принудительно просим UI перерисоваться
    //     this.requestUpdate();

    //     console.groupEnd();
    // }
    // async openChat(ev) {
    //     ev?.preventDefault?.();
    //     const jid = this.model.get('jid');

    //     console.group(`%c[ROSTER OPEN CHAT]: ${jid}`, 'background: #222; color: #3498db');

    //     // 1. Открываем чат
    //     await api.chats.open(jid, {}, true);

    //     // 2. Обнуляем в Chatbox (для окна чата и вкладки активных чатов)
    //     const cb = _converse.chatboxes.get(jid);
    //     if (cb) {
    //         cb.save({
    //             'num_unread': 0,
    //             'num_unread_general': 0,
    //             'last_read': new Date().toISOString(),
    //         });
    //     }

    //     // 3. Обнуляем в самой модели контакта (this.model)
    //     // Именно отсюда твой renderContact может брать цифру 1
    //     if (this.model && this.model.get('num_unread') !== 0) {
    //         console.log('Clearing unread count on RosterContact model');
    //         this.model.save({
    //             'num_unread': 0,
    //         });
    //     }

    //     // 4. Принудительно просим UI перерисоваться
    //     this.requestUpdate();
    //     // _converse.api.views.get('controlbox')?.requestUpdate();

    //     console.groupEnd();
    // }
    // openChat(ev) {
    //     ev?.preventDefault?.();
    //     api.chats.open(this.model.get('jid'), {}, true);
    // }

    /**
     * @param {MouseEvent} ev
     */
    addContact(ev) {
        ev?.preventDefault?.();
        api.modal.show('converse-add-contact-modal', { contact: this.model }, ev);
    }

    /**
     * @param {MouseEvent} ev
     */
    async removeContact(ev) {
        ev?.preventDefault?.();
        await removeContact(this.model, true);
    }

    /**
     * @param {MouseEvent} ev
     */
    async showUserDetailsModal(ev) {
        ev?.preventDefault?.();
        ev.preventDefault();
        if (this.model instanceof _converse.exports.Profile) {
            api.modal.show('converse-profile-modal', { model: this.model }, ev);
        } else {
            api.modal.show('converse-user-details-modal', { model: this.model }, ev);
        }
    }

    /**
     * @param {MouseEvent} ev
     */
    async blockContact(ev) {
        ev?.preventDefault?.();
        await blockContact(this.model);
    }

    /**
     * @param {MouseEvent} ev
     */
    async acceptRequest(ev) {
        ev?.preventDefault?.();
        api.modal.show('converse-accept-contact-request-modal', { contact: this.model }, ev);
    }

    /**
     * @param {MouseEvent} ev
     */
    async declineRequest(ev) {
        ev?.preventDefault?.();
        declineContactRequest(this.model);
    }
}

api.elements.define('converse-roster-contact', RosterContactView);
